import { useCallback, useState } from "react";
import useLocalTable from "../../../common/hooks/useLocalTable";
import { createFiltersFromFilterData } from "../../../../utils/formViews";
import { TableFilterData } from "../../../../types/common/table/table-types";

const getFilters = (searchString: string, filterData: TableFilterData[]) => {
    const filters: TableFilterData[] = [];


    if (filterData) {
        const createdFilters = createFiltersFromFilterData(filterData);
        filters.push(...createdFilters);
    }

    return filters;
};

const useCreateHistoryTable = (data, getFilters) => {
    const { rows, onFilter, pagination } = useLocalTable(data, true);

    const [filterData, setFilterData] = useState([]);
    const [searchString, setSearchString] = useState("");

    const setFilterDataCallback = useCallback(
        (filterData) => {
            setFilterData(filterData);
            onFilter(getFilters(searchString, filterData));
        },
        [searchString, onFilter, getFilters]
    );

    const setSearchStringCallback = useCallback(
        (searchString) => {
            setSearchString(searchString);
            onFilter(getFilters(searchString, filterData));
        },
        [filterData, onFilter, getFilters]
    );

    return {
        rows,
        pagination,
        searchString,
        setSearchString: setSearchStringCallback,
        filterData,
        setFilterData: setFilterDataCallback,
    };
};

    const useRequestDetailedHistoryTable = (history) => {
        const getDialogFilters = useCallback(
            async ({ field, search = "" }) => {
                const lowerSearch = search.toLowerCase();
                let keys;

                switch (field) {
                    case "operation": {
                        keys = history.filter(({ operation }) => operation?.toLowerCase().includes(lowerSearch)).map(({ operation }) => operation);
                        break;
                    }
                    case "status": {
                        keys = history.filter(({ status }) => status?.toLowerCase().includes(lowerSearch)).map(({ status }) => status);
                        break;
                    }
                    case "authorText": {
                        keys = history.filter(({ author }) => author?.toLowerCase().includes(lowerSearch)).map(({ author }) => author);
                        break;
                    }
                    case "oldValue": {
                        keys = history.filter(({ oldValue }) => oldValue?.toLowerCase().includes(lowerSearch)).map(({ oldValue }) => oldValue);
                        break;
                    }
                    case "newValue": {
                        keys = history.filter(({ newValue }) => newValue?.toLowerCase().includes(lowerSearch)).map(({ newValue }) => newValue);
                        break;
                    }
                    case "additionalInfo": {
                        keys = history
                            .filter(({ additionalInfo }) => additionalInfo?.toLowerCase().includes(lowerSearch))
                            .map(({ additionalInfo }) => additionalInfo);
                        break;
                    }
                }

                const uniqueKeys = [...new Set(keys)];
                const rows = uniqueKeys.map((key) => ({ key, text: key }));
                return { rows, total: rows.length };
            },
            [history]
        );

    // const viewTable = useEntityFormViewTable(history, getFilters);
    const viewTable = useCreateHistoryTable(history, getFilters);

    return {
        ...viewTable,
        getDialogFilters,
    };
};

export default useRequestDetailedHistoryTable;
